import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrEquipmentService, SrEquipmentsGet } from '@app/services/sr-equipment.service';

@Component({
    selector: 'tt-sr-equipments',
    templateUrl: './sr-equipments.component.html',
    styleUrls: ['./sr-equipments.component.css'],
    standalone: false,
})
export class SrEquipmentsComponent implements OnInit {
    public page?: SrEquipmentsGet;
    public items: Item[] = [];
    public error = '';
    constructor(private readonly equipment: SrEquipmentService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.equipment.getEquipments({ resource_id: String(this.navigator?.params['resource_id'] ?? '') });
            if (this.page.resource_id?.trim()) this.items = await this.equipment.getEquipmentList({ resource_id: this.page.resource_id });
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
    }

    public newEquipment(): void {
        if (this.page) this.navigator?.go({ to: 'srequipment-test', parms: { resource_id: this.page.resource_id, srequipment_keyno: '0' } });
    }

    public openItem(event: { item: Item; event: MouseEvent }): void {
        if (!event.item.item_state) return;
        const target = { to: event.item.item_state === 'srequipment' ? 'srequipment-test' : event.item.item_state, parms: event.item.item_parms };
        if (event.event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
}
